import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { Icon, IconStack } from 'js/components';

import { faPeopleGroup } from '@fortawesome/pro-solid-svg-icons';
import { faEmptySet } from '@fortawesome/pro-regular-svg-icons';

import UserGroupStatCard from './UserGroupStatCard';

function ManagedProductUserGroups({ managedProduct }) {
  const { user_groups = [] } = managedProduct?.stats ?? {};
  console.log(managedProduct);

  if (user_groups.length === 0) {
    return (
      <Card>
        <CardBody>
          <div className="media text-muted mt-4 mb-4">
            <IconStack size="4x" fixedWidth className="mr-3">
              <Icon icon={faPeopleGroup} />
              <Icon icon={faEmptySet} transform="shrink-13 down-1" inverse />
            </IconStack>
            <div className="media-body">
              <p>This managed product isn't associated with any user groups.</p>
              <p>
                Add a managed product to a user group from that group's
                settings. You will be able to see all the user groups a managed
                product supports here.
              </p>
            </div>
          </div>
        </CardBody>
      </Card>
    );
  }

  return (
    <>
      {user_groups.map((ug) => {
        return <UserGroupStatCard key={ug.id} userGroup={ug} />;
      })}
    </>
  );
}
export default ManagedProductUserGroups;
